<style scoped lang="scss">
.group_card {
  width: 100%;
  padding: 1rem 1.5rem;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: .25rem!important;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, .05);
}
</style>

<template>
  <section>
    <!-- main contents -->
    <div class="group_card mb-3" >
      <h5 class="pb-2 mb-0 text-center text-md-left text-lg-left text-xl-left">
        <!-- <font-awesome-icon :icon="faGlobe" /> -->
        {{ data.name }}
        <b-badge pill variant="primary ml-2 mr-1">{{ options.area[data.server] }}</b-badge>
        <b-badge pill variant="warning" class="">
          Port
          <small>{{ data.port }}</small>
          <!-- <span class="text-light">Port - 10123</span> -->
        </b-badge>
        <b-badge pill variant="light" class="">
          <small>{{ ownerMail }}</small>
          <!-- <span class="text-light">Port - 10123</span> -->
        </b-badge>
      </h5>
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div class="text-muted media-body">
          {{ data.description }}
        </div>
        <div class="my-2 my-md-0 text-center text-md-right">
          <!-- <b-button
            v-b-toggle="`${data['.key']}_sites_detail`"
            :disabled="theClients.length === 0"
            class="d-inline px-1 py-0 mr-2 align-middle"
            size="sm"
            variant="outline-dark"
          >
            <font-awesome-icon :icon="faChartLine" />
            {{ theClients.length === 0 ? 'No sites yet' : 'Site Status' }}
          </b-button> -->
          <b-button class="d-inline px-1 py-0" size="sm" variant="outline-danger" @click="clickDeleteGroup(data)">
            <font-awesome-icon :icon="faTrashAlt" />
            Delete
          </b-button>
        </div>
      </div>

      <div class="pt-1 mt-2 border-top">
        <h6 class="text-center py-2 mb-0 font-weight-bold">
          <font-awesome-icon :icon="faSitemap" />
          Sites
          <b-button
            v-if="theClients.length > 0"
            id="siteDetailCtrl"
            size="sm"
            variant="outline-secondary"
            :class="['rounded-circle', 'm-0', 'p-0' ,'border-0', showSitesDetail ? '' : 'animated infinite rubberBand']"
            @click="clickSiteDetailTrigger"
            v-b-tooltip.hover.top="'show / hide more detail'"
          >
            <font-awesome-icon :icon="showSitesDetail ? faChevronUp : faChevronDown" class="m-2 align-middle"/>
          </b-button>
        </h6>
        <transition
          name="custom-classes-transition"
          enter-active-class="animated fadeInDown"
        >
          <div
            v-if="!showSitesDetail"
            class="col d-flex flex-wrap justify-content-center align-items-center"
          >
            <b-badge
              v-for="c in theClients"
              :key="c.cid"
              :class="['border', 'm-1', c.enabled ? 'border-success' : 'border-danger', c.enabled ? 'text-success' : 'text-danger']"
              variant="light"
              pill
              v-b-tooltip.hover.bottomright.html="`
                <dl>
                  <dt class='small font-weight-bold'>Name</dt>
                  <dd class='small'>${c.name}</dd>
                  <dt class='small font-weight-bold'>MAC</dt>
                  <dd class='small'>${c.mac}</dd>
                  <dt class='small font-weight-bold'>Description</dt>
                  <dd class='small'>${c.description}</dd>
                </dl>
              `"
            >
              <span class="h6 align-middle mr-3">{{ c.sitename || 'Anonymous'}}</span>
              <font-awesome-icon :icon="c.enabled ? faLink : faUnlink" class="mr-1 align-middle"/>
              <span class="align-middle"> {{ clientUptimeDictionary[c.cid] }}</span>
            </b-badge>
            <div
              v-if="theClients.length === 0"
              class="text-secondary font-italic font-weight-light"
            >
              Nothing here yet.
            </div>
          </div>
        </transition>
      </div>

      <div>
        <!-- <Card4Sites /> -->
        <transition
          name="custom-classes-transition"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
        >
          <div id="sites_detail" v-if="showSitesDetail">
            <b-card-group class="d-none d-sm-flex" :style="{height: `${styleFixCard.height}px`}">
              <b-card no-body class="col-sm-4 px-0">
                <b-list-group
                  v-if="loaded.fbClientDictionary"
                  flush
                  style="overflow: auto"
                >
                  <b-list-group-item
                    v-for="c in theClients"
                    :key="c.cid"
                    :disabled="c.sitename == null"
                    @click="chooseSite(c)"
                    :class="['btn', 'btn-light']"
                  >
                    <div
                      :class="['d-flex', 'flex-row', 'flex-lg-row', 'justify-content-between', 'align-items-center', c.enabled ? 'text-success' : 'text-danger']"
                    >
                      <span class="text-truncate ">
                        <!-- <transition name="custom-classes-transition" enter-active-class="animated fadeInLeft">
                          <font-awesome-icon :icon="faAngleDoubleRight" size="lg" class="text-dark" v-if="c.cid === selectedClient.cid"/>
                        </transition> -->
                        {{ c.sitename || 'Anonymous'}}
                      </span>
                      <small>
                        <font-awesome-icon :icon="c.enabled ? faLink : faUnlink" class="mr-2, mw-20"/>
                        {{ clientUptimeDictionary[c.cid] }}
                      </small>
                    </div>
                    <transition
                      name="custom-classes-transition"
                      enter-active-class="animated fadeIn"
                      leave-active-class="animated fadeOut"
                    >
                      <div
                        v-if="c.cid === selectedClient.cid"
                      >
                        <dl class="text-left px-2 my-2" style="border-left: 5px solid rgba(85, 85, 85, 0.6)">
                          <dt class="small font-weight-bold">Name</dt>
                          <dd class='small'>{{c.name}}</dd>
                          <dt class="small font-weight-bold">MAC</dt>
                          <dd class='small'>{{c.mac}}</dd>
                          <dt class="small font-weight-bold">Description</dt>
                          <dd class="small" style="white-space: normal">{{c.description}}</dd>
                        </dl>
                      </div>
                    </transition>
                  </b-list-group-item>
                </b-list-group>

                <Loading v-else mode="area"/>
              </b-card>
              <b-card body-class="p-0">
                <RealtimeLineChart :client="syncedSelectedClient" :customStyle="styleFixCard"/>
              </b-card>
            </b-card-group>
          </div>
        </transition>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <b-modal
      title="Confirmation required"
      header-text-variant="dark"
      ref="deleteGroupModalRef"
      centered
      @hidden="rmGroupTarget = {}"
    >
      <h6 class="text-danger">
        You are going to remove <strong>{{ rmGroupTarget.name }}</strong>. Removed group CANNOT be restored! Are you ABSOLUTELY sure?
      </h6>
      <div slot="modal-footer">
        <b-button size="sm" variant="danger" class="float-right" @click="clickConfirm">Confirm</b-button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faAngleDoubleLeft, faAngleDoubleRight, faChartLine, faChevronDown, faChevronUp, faExclamationCircle, faExclamationTriangle, faGlobe, faLink, faUnlink, faSitemap, faTrashAlt } from '@fortawesome/fontawesome-free-solid'
import Card4Sites from '@/components/Card4Sites'
import Loading from '@/components/Loading'
import RealtimeLineChart from '@/components/RealtimeLineChart'
import { getDbRef } from '@/firebaseRef'

export default {
  props: {
    mode: {
      type: String,
      default: 'overview' /* mode: 'overview', 'detail' */
    },
    data: {
      type: [Array, Object],
      default: () => []
    }
  },
  components: {
    Card4Sites,
    FontAwesomeIcon,
    Loading,
    RealtimeLineChart
  },
  firebase: {
    fbClientDictionary: {
      source: getDbRef('client'),
      asObject: true,
      readyCallback: function () {
        this.loaded.fbClientDictionary = true
      }
    }
  },
  data () {
    return {
      faAngleDoubleLeft,
      faAngleDoubleRight,
      faChartLine,
      faChevronDown,
      faChevronUp,
      faExclamationCircle,
      faExclamationTriangle,
      faGlobe,
      faLink,
      faUnlink,
      faSitemap,
      faTrashAlt,
      /* timer */
      currentTime: {},
      /* user info */
      ownerMail: null,
      /* options */
      options: {
        area: {
          asia: 'Asia',
          eu: 'Europe'
        }
      },
      /* data loading's status, true for loaded. */
      loaded: {
        fbClientDictionary: false
      },
      /* group's sites detail collapse ctrl */
      showSitesDetail: false,
      /* selected client */
      selectedClient: { cid: null },
      rmGroupTarget: {},
      /* style objects */
      styleFixCard: {
        height: 300
      }
    }
  },
  computed: {
    clientUptimeDictionary () {
      if (this.loaded.fbClientDictionary) {
        const cli = this.fbClientDictionary
        const now = this.currentTime.time
        return _.transform(cli, (result, value, key) => {
          if (key !== '.key') {
            const { uptime } = value
            result[key] = moment(uptime).to(now, true)
          }
        }, {})
      }
      return []
    },
    syncedSelectedClient () {
      if (this.selectedClient.cid === null) {
        return this.selectedClient
      } else {
        return _.find(this.theClients, {cid: this.selectedClient.cid})
      }
    },
    theClients () {
      const { clients } = this.data
      if (this.loaded.fbClientDictionary) {
        return _.transform(clients, (result, value, key) => {
          result.push({
            'cid': key,
            ...this.fbClientDictionary[key]
          })
        }, [])
      } else {
        return []
      }
    },
    ...mapState({
      uid: (state) => state.user.uid,
      useRole: (state) => state.user.role
    })
  },
  methods: {
    showModal (modalRef) {
      this.$refs[modalRef].show()
    },
    hideModal (modalRef) {
      this.$refs[modalRef].hide()
    },
    chooseSite (c) {
      if (this.selectedClient.cid === c.cid) { // clear selected
        this.selectedClient = { cid: null }
      } else { // record selected
        this.selectedClient = c
      }
    },
    clickSiteDetailTrigger () {
      this.showSitesDetail = !this.showSitesDetail
      if (!this.showSitesDetail) { // if false, clear
        this.selectedClient = { cid: null }
      }
    },
    clickDeleteGroup (target) {
      this.showModal('deleteGroupModalRef')
      this.rmGroupTarget = target
    },
    clickConfirm () {
      this.hideModal('deleteGroupModalRef')
      getDbRef(`group/${this.rmGroupTarget['.key']}`).update({deleted: true})
    }
  },
  mounted () {
    /* trigger timer */
    this.currentTime.timer = setInterval(() => {
      this.currentTime = {
        ...this.currentTime,
        time: (new Date()).getTime()
      }
    }, 1000)
    /* retreive group owner info */
    getDbRef(`user/${this.uid}`).once('value').then((snapshot) => {
      // console.log(snapshot.val())
      this.ownerMail = snapshot.val().email
    })
  },
  beforeDestroy () {
    /* stop timer */
    clearInterval(this.currentTime.timer)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Card4Groups.vue